import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'cat4mro' },
    },
    {
      path: '/cat4mro',
      name: 'cat4mro',
      redirect: { name: 'cat4mro.search' },
      component: {
        render(c) { return c('router-view'); },
      },
      meta: {
        breadcrumb: 'CAT4MRO',
      },
      children: [
        {
          path: 'search',
          name: 'cat4mro.search',
          component: () => import('@/pages/cat4mro/search'),
          meta: {
            breadcrumb: 'Search',
          },
        },
      ],
    },
    {
      path: '/shoppingcart',
      name: 'shoppingcart',
      component: () => import('@/pages/cat4mro/shoppingcart'),
      meta: {
        breadcrumb: 'Shopping Cart',
      },
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: () => import('@/pages/cat4mro/checkout'),
      meta: {
        breadcrumb: 'Checkout',
      },
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: () => import('@/pages/cat4mro/catalog'),
      meta: {
        breadcrumb: 'Catalog',
      },
    },
    {
      path: '/catalog/:tax',
      name: 'catalog.products',
      component: () => import('@/pages/cat4mro/catalog'),
      meta: {
        breadcrumb: 'Catalog',
      },
    },
    {
      path: '/catalog/:tax/item/:item',
      name: 'catalog.products.item',
      component: () => import('@/pages/cat4mro/item'),
      meta: {
        breadcrumb: 'Item Catalog',
      },
    },
    {
      path: '/expressquote',
      name: 'expressquote',
      component: () => import('@/pages/quote/expressquote'),
      meta: {
        breadcrumb: 'Express Quote',
      },
    },
    {
      path: '/checkouterp',
      name: 'checkouterp',
      component: () => import('@/pages/quote/checkouterp'),
      meta: {
        breadcrumb: 'Checkout to ERP',
      },
    },
    {
      path: '/rfq',
      name: 'rfq',
      component: {
        render(c) { return c('router-view'); },
      },
      redirect: { name: 'rfq.search' },
      meta: {
        breadcrumb: 'RFQ',
      },
      children: [
        {
          path: 'search',
          name: 'rfq.search',
          component: () => import('@/pages/rfq/search'),
          meta: {
            breadcrumb: 'Panel',
          },
        },
        {
          path: 'request',
          name: 'rfq.request',
          component: () => import('@/pages/rfq/request'),
        },
      ],
    },
  ],
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
});



// WEBPACK FOOTER //
// ./src/router/index.js